import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/customs-referential',
}).lazy(() => import('./customs-referential.lazy').then((d) => d.Route))
